import React from 'react';
import TopBody from '../components/TopBody';
import RecsiteAPI from '../service/RecsiteAPI';
import moment from 'moment/moment';
import config from '../config/constants';
import PoweredBy from '../components/PoweredBy';
import IFrameService from '../service/IFrameService';


export default class VacancyApply extends React.Component {
	
	state = {
		vacancy: {},
		user: {
			username: '',
			password: ''
		},
		candidate: {
			firstName: '',
			lastName: '',
			email: '',
			mobile: '',
			file: 'path',
			terms: false,
			jobId: this.props.match.params.vacancyId
		}
	};
	
	componentDidMount = () => {
		RecsiteAPI.getVacancyById(this.props.match.params.vacancyId).then(data => {
			console.log(data, 'data of JOB');
			this.setState({
				vacancy: {
					jobId: data.vacancy_id ? data.vacancy_id : 0,
					jobTitle: data.title ? data.title : 'none',
					jobDescription: data.description ? data.description : 'none',
					jobType: data.duration ? data.duration : 'none',
					postedDate: data.postdate ? moment(data.postdate).format('DD/MM/YYYY') : 'none',
					startDate: data.startdate ? moment(data.startdate).format('DD/MM/YYYY') : 'none',
					contact: data.consultant ?  data.consultant.name : 'none',
					salary: data.salary_level ? data.salary_level.name : 'none'
				}
			})
		});
	};
	
	componentDidUpdate = () => {
		IFrameService.parentData();
	};
	
	render = () => {
		
		return (
			<div className="container">
				<TopBody header={'you are applying for'} title={this.state.vacancy.jobTitle}/>
				<div className="flex-parent">
					<div className="flex-child-list">
						<ul>
							<li className="gfield gfield_genesis">
								{(this.state.candidate.firstName === '') && (
									<label className="gfield_label" htmlFor="name_first">First Name</label>)}
								<div className="ginput_container">
									<input
										name="name_first"
										id="name_first"
										type="text"
										value={this.state.candidate.firstName}
										onChange={(event) => {
											this.setState({
												candidate: { ...this.state.candidate, firstName: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							<li className="gfield gfield_genesis">
								{(this.state.candidate.lastName === '') && (
									<label className="gfield_label" htmlFor="name_last">Last Name</label>)}
								<div className="ginput_container">
									<input
										name="name_last"
										id="name_last"
										type="text"
										value={this.state.candidate.lastName}
										onChange={(event) => {
											this.setState({
												candidate: { ...this.state.candidate, lastName: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							<li className="gfield gfield_genesis">
								{(this.state.candidate.email === '') && (
									<label className="gfield_label" htmlFor="email">Email Address</label>)}
								<div className="ginput_container">
									<input
										name="email"
										id="email"
										type="email"
										value={this.state.candidate.email}
										onChange={(event) => {
											this.setState({
												candidate: { ...this.state.candidate, email: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							<li className="gfield gfield_genesis">
								{(this.state.candidate.mobile === '') && (
									<label className="gfield_label" htmlFor="mobile">Mobile Number</label>)}
								<div className="ginput_container">
									<input
										name="mobile"
										id="mobile"
										type="number"
										value={this.state.candidate.mobile}
										onChange={(event) => {
											this.setState({
												candidate: { ...this.state.candidate, mobile: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							<li className="gfield gfield_genesis_file_container">
								<label className="gfield_label text-center user-content__smaller block" htmlFor="file">Upload your CV (Max size 4Mb, .doc,
									.docx
									and .pdf only)*</label>
								<div className="ginput_container">
									<input
										className="inputfile"
										name="file"
										id="file"
										type="file"
									/>
									<label htmlFor="file" className="btn btn_submit">
										<span className="text-outline text-center">Choose File</span>
										<span className="btn_bg"/>
									</label>
								</div>
							</li>
							<li className="gfield gfield_genesis_checkbox">
								<div className="ginput_container ginput_container_checkbox">
									<ul className="gfield_checkbox">
										<li>
											<input
												name="Terms"
												type="checkbox"
												id="terms"
												value={this.state.candidate.terms}
												onChange={(event) => {
													this.setState({
														candidate: { ...this.state.candidate, terms: event.target.value }
													})
												}}
											/>
											<label htmlFor="terms">I agree to the Terms & Conditions and Privacy Policy</label>
										</li>
									</ul>
								</div>
							</li>
							<li className="gfield gfield_submit">
								<button className="btn btn_submit">
									<span className="text-outline text-center">Register &amp; Apply</span>
									<span className="btn_bg"/>
								</button>
							</li>
						</ul>
					</div>
				</div>
				
				<div className="flex-parent rcg-vacancy-apply-middle-title">
					<div className="flex-child">
						<h3 className="rcg-small-title text-outline">Already registered?</h3>
					</div>
				</div>
				
				<div className="flex-parent">
					<div className="flex-child-list">
						<ul className="vacancy-apply-list">
							
							<li className="gfield gfield_genesis">
								{(this.state.user.username === '') && (
									<label className="gfield_label" htmlFor="username">Username</label>)}
								<div className="ginput_container">
									<input
										name="username"
										id="username"
										type="text"
										value={this.state.user.username}
										onChange={(event) => {
											this.setState({
												user: { ...this.state.user, username: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							
							<li className="gfield gfield_genesis">
								{(this.state.user.password === '') && (
									<label className="gfield_label" htmlFor="password">Password</label>)}
								<div className="ginput_container">
									<input
										name="password"
										id="password"
										type="password"
										value={this.state.user.password}
										onChange={(event) => {
											this.setState({
												user: { ...this.state.user, password: event.target.value }
											})
										}}
									/>
								</div>
							</li>
							
							<li className="gfield gapply_login_button">
								<button className="btn btn_submit">
									<span className="text-outline text-center">Login &amp; Apply</span>
									<span className="btn_bg"/>
								</button>
							</li>
							
						</ul>
					</div>
				</div>
				
				<div className="flex-parent">
					<div className="flex-child-list">
						<p className="user-content rcg-forget-link">
							<a
								href={`${config.PROTOCOL}://${config.DOMAIN}/index.php?option=com_user&view=reset&lang=en`}
								title="Forgot your password"
								target="__blank"
							>Forgot your password
							</a>&nbsp;/&nbsp;
							<a
								href={`${config.PROTOCOL}://${config.DOMAIN}/index.php?option=com_user&view=remind&lang=en`}
								title="Forgot your password"
								target="__blank"
							>Forgot your username
							</a>
						</p>
					</div>
				</div>
			
				<PoweredBy />
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/pages/VacancyApply.js